/*
 * Cookie
 */

export default {
    read: function (name) {
        const value = document.cookie.match(`(?:^|;)\\s*${name}=([^;]*)`);
        return value ? decodeURIComponent(value[1]) : null;
    },
    write: function (value) {
        let str = `${value.name}=${encodeURIComponent(value.value)}`;
        if (value.domain) {
            str += `; domain=${value.domain}`;
        }
        str += `; path=${value.path || '/'}`;
        if (value.day) {
            const time = new Date();
            time.setTime(time.getTime() + value.day * 24 * 60 * 60 * 1000);
            str += `; expires=${time.toUTCString()}`;
        }
        if (value.expires) {
            str += `; expires=${value.expires.toUTCString()}`;
        }
        document.cookie = str;
        return;
    },
    del: function (name, options = undefined) {
        const opt = options || {};
        opt.name = name;
        opt.day = -1;
        opt.value = 'a';
        this.write(opt);
        return;
    },
    clearPwForm: function () {
        this.del('account_id');
        this.del('account_id');
        this.del('user_id');
        this.del('au_token');
        this.del('token');
        this.del('c_token');
    },
    clearAll: function () {
        this.del('c_token');
        this.del('account_id');
        this.del('user_id');
        this.del('au_token');
        this.del('token');
        this.del('account_id');
        window.sessionStorage.removeItem('userinfo');
    },
    hasToken: function () {
        return !!this.read('au_token');
    },
};
